"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 24C9.62663 24 7.30655 23.2962 5.33316 21.9776C3.35977 20.6591 1.8217 18.7849 0.913451 16.5922C0.00519943 14.3995 -0.232441 11.9867 0.230582 9.65892C0.693605 7.33115 1.83649 5.19295 3.51472 3.51472C5.19295 1.83649 7.33115 0.693605 9.65892 0.230582C11.9867 -0.232441 14.3995 0.00519943 16.5922 0.913451C18.7849 1.8217 20.6591 3.35977 21.9776 5.33316C23.2962 7.30655 24 9.62663 24 12C23.9966 15.1815 22.7312 18.2318 20.4815 20.4815C18.2318 22.7312 15.1815 23.9966 12 24ZM12 2.00001C10.0222 2.00001 8.08879 2.5865 6.4443 3.68531C4.79981 4.78412 3.51809 6.34591 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C21.9971 9.34873 20.9426 6.80689 19.0679 4.93215C17.1931 3.05742 14.6513 2.00292 12 2.00001Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13 15.0001H11V14.2571C10.9852 13.5515 11.1596 12.8548 11.5049 12.2393C11.8503 11.6239 12.3541 11.1121 12.964 10.7571C13.3335 10.5536 13.6292 10.2385 13.8088 9.85679C13.9884 9.47513 14.0427 9.04645 13.964 8.63205C13.8861 8.23725 13.6923 7.87464 13.4073 7.59054C13.1223 7.30644 12.759 7.11373 12.364 7.03705C12.0757 6.98369 11.7792 6.99436 11.4955 7.06831C11.2118 7.14226 10.9479 7.27767 10.7223 7.46497C10.4968 7.65226 10.3152 7.88685 10.1903 8.15212C10.0655 8.4174 10.0005 8.70688 10 9.00005H8C8.00025 8.29456 8.18709 7.60168 8.54156 6.9917C8.89603 6.38172 9.40552 5.87635 10.0184 5.52684C10.6312 5.17732 11.3256 4.99611 12.031 5.00159C12.7365 5.00706 13.428 5.19902 14.0353 5.55799C14.6427 5.91697 15.1443 6.43018 15.4892 7.04559C15.8342 7.66099 16.0102 8.35668 15.9996 9.0621C15.9889 9.76751 15.7918 10.4575 15.4283 11.0622C15.0649 11.6669 14.548 12.1647 13.93 12.5051C13.6348 12.6897 13.3933 12.9488 13.2301 13.2563C13.0668 13.5639 12.9875 13.9091 13 14.2571V15.0001Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13 17H11V19H13V17Z",
    fill: fill
  }));
};

exports["default"] = _default;